import { createAction, props } from '@ngrx/store';

import {
  type ChatMessagesResponse,
  type ChatPersistedMessage,
  type SendChatMessageInput,
} from '@blaze-dashboard/ai-chat-domain';

export const sendChatMessage = createAction(
  '[AI Chat] Send message',
  props<{ clientId: string; message: SendChatMessageInput }>(),
);

export const sendChatMessageSuccess = createAction(
  '[AI Chat] Send message success',
  props<{ chatConversationId: string; clientId: string; message: ChatPersistedMessage }>(),
);

export const sendChatMessageFailure = createAction(
  '[AI Chat] Send message failure',
  props<{
    chatConversationId?: string;
    clientId: string;
    message: SendChatMessageInput;
    error: string;
  }>(),
);

export const retrySendChatMessage = createAction('[AI Chat] Retry send chat message');

export const loadChatMessagesSuccess = createAction(
  '[AI Chat] Load chat messages success',
  props<{ chatMessagesResponse: ChatMessagesResponse }>(),
);
